import { apiService } from './api';
import {
  LoginRequest,
  RegisterRequest,
  AuthResponse,
  RefreshTokenRequest,
  ResetPasswordRequest,
  User,
  ApiResponse
} from '../types';

export const authService = {
  async login(data: LoginRequest): Promise<AuthResponse> {
    const response = await apiService.post<AuthResponse>('/auth/login', data);
    return response.data;
  },

  async register(data: RegisterRequest): Promise<User> {
    const response = await apiService.post<User>('/auth/register', data);
    return response.data;
  },

  async refreshToken(data: RefreshTokenRequest): Promise<AuthResponse> {
    const response = await apiService.post<AuthResponse>('/auth/refresh', data);
    return response.data;
  },

  async resetPassword(data: ResetPasswordRequest): Promise<ApiResponse<null>> {
    const response = await apiService.post<ApiResponse<null>>('/auth/reset-password', data);
    return response.data;
  },

  async getProfile(): Promise<User> {
    const response = await apiService.get<User>('/users/me');
    return response.data;
  },

  async updateProfile(data: Partial<User>): Promise<User> {
    const response = await apiService.put<User>('/users/me', data);
    return response.data;
  },

  async sendForgotPasswordOTP(email: string): Promise<void> {
    await apiService.post('/auth/forgot-password', { email });
  },

  async resetPasswordWithOTP(email: string, otp: string, newPassword: string): Promise<void> {
    await apiService.post('/auth/forgot-password/reset', { email, otp, newPassword });
  },

  async submitAccessRequest(data: { name: string; organizationName: string; email: string; mobile: string; message?: string }): Promise<void> {
    await apiService.post('/public/access-requests', data);
  },

  logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    localStorage.removeItem('restro360_active_restaurant');
    localStorage.removeItem('restro360_active_role');
    window.location.href = '/login';
  },

  isAuthenticated(): boolean {
    return !!localStorage.getItem('accessToken');
  },

  getStoredUser(): User | null {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  storeAuthData(authResponse: AuthResponse, user?: User) {
    localStorage.setItem('accessToken', authResponse.accessToken);
    localStorage.setItem('refreshToken', authResponse.refreshToken);
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    }
  }
};